module.exports = __webpack_public_path__ + "static/img/researcherAvatar.2410e8c.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/content/researcherAvatar.png
// module id = AjFw
// module chunks = 3